import { useEffect, useState } from "react";
import { waLink, WHATSAPP_INTENTS } from "../config";

const navLinks = [
  { label: "Menü", href: "#menu" },
  { label: "Nasıl Çalışır?", href: "#nasil-calisir" },
  { label: "Fiyatlar", href: "#fiyat" },
  { label: "Kurumsal", href: "#kurumsal" },
  { label: "Bölgeler", href: "#bolge" },
  { label: "Hakkımızda", href: "#hikaye" },
  { label: "Sık Sorulanlar", href: "#sss" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex h-16 md:h-20 items-center justify-between gap-4">
          {/* Logo */}
          <a href="#top" className="flex items-center gap-3 cursor-pointer">
            <div className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-primary-500 flex items-center justify-center shrink-0">
              <i className="ri-vip-crown-line text-background-50 text-xl"></i>
            </div>
            <div className="leading-none">
              <span className="block font-heading text-lg md:text-xl font-bold text-foreground-950 whitespace-nowrap">
                Meliha Sultan
              </span>
              <span className="block text-[10px] md:text-[11px] tracking-[0.25em] text-foreground-600 font-semibold whitespace-nowrap">
                EV YEMEKLERİ
              </span>
            </div>
          </a>

          {/* Center nav */}
          <nav className="hidden lg:flex items-center gap-7">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-sm font-semibold text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Right actions */}
          <div className="hidden lg:flex items-center gap-3">
            <a
              href={waLink(WHATSAPP_INTENTS.hero)}
              target="_blank"
              rel="nofollow noopener"
              className="w-10 h-10 rounded-full bg-accent-100 text-accent-900 flex items-center justify-center hover:bg-accent-200 transition-colors cursor-pointer"
              aria-label="WhatsApp"
            >
              <i className="ri-whatsapp-line text-xl"></i>
            </a>
            <a
              href="#giris"
              className="text-sm font-bold text-foreground-800 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
            >
              Giriş Yap
            </a>
            <a
              href="#menu"
              className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-bold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              MENÜMÜ OLUŞTUR
            </a>
          </div>

          {/* Mobile hamburger */}
          <button
            onClick={() => setMobileOpen((v) => !v)}
            className="lg:hidden w-10 h-10 rounded-md flex items-center justify-center text-foreground-900 cursor-pointer"
            aria-label="Menü"
          >
            <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile menu panel */}
      {mobileOpen && (
        <div className="lg:hidden bg-background-50 border-b border-background-200 shadow-sm animate-fade-in">
          <nav className="px-4 py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMobileOpen(false)}
                className="py-3 text-sm font-semibold text-foreground-800 border-b border-background-200 last:border-0 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#menu"
              onClick={() => setMobileOpen(false)}
              className="mt-3 py-3 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-bold text-center cursor-pointer"
            >
              MENÜMÜ OLUŞTUR
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}